import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Maguey from '../../../img/magueysito.svg'
import LogoMagueySVG from '../../../img/logoBlancoSVG2.svg';
import estilos from './MarcadorDeZonaComponent.module.css'

function MarcadorComponent(props) {

    const punto = props.punto

    return (
        <Fragment>
        <div className={`${estilos.pin1}`} style={{ backgroundColor: punto.pin, cursor: 'pointer'}} title={punto.instalacionnombre} >
        <img src={LogoMagueySVG}/>
        <p className='badge' style={{ backgroundColor: 'white', fontSize: '15px', color: 'black' }}>{punto.instalacionnombre}</p>     
        </div> 
        
        </Fragment> 
    );
};


export default withRouter(MarcadorComponent)
